module.exports = __webpack_public_path__ + "img/202406-xl.625de2f9.png";